var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a-modal",
    {
      attrs: {
        visible: _vm.visible,
        title: _vm.$t("auto.markContactsAsRead", { count: _vm.selectedCount }),
        "ok-text": _vm.$t("auto.mark"),
        "cancel-text": _vm.$t("auto.cancel"),
        width: "450px",
      },
      on: { ok: _vm.handleConfirm, cancel: _vm.handleCancel },
    },
    [
      _c("div", { staticClass: "modal-content" }, [
        _c("p", [
          _vm._v(
            _vm._s(
              _vm.$t("auto.selectedContactsWillBeMarkedAsRead", {
                count: _vm.selectedCount,
              })
            )
          ),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }